const signatureTypes = Object.freeze({
	signaturePad: 1,
	email: 2,
	manual: 3,
});
    
export const SignatureTypes = signatureTypes;